import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { TrailListComponent } from "../../../trail/component/trail-list/trail-list.component";
import { VesselDetailsComponent } from "../vessel-details/vessel-details.component";
import { VesselPhotosComponent } from "../vessel-photos/vessel-photos.component";
import { VesselMachineryListComponent } from "../vessel-machinery-list/vessel-machinery-list.component";
import { VesselDpControlListComponent } from "../vessel-dp-control-list/vessel-dp-control-list.component";
import { VesselRedundancyGroupListComponent } from "../vessel-redundancy-group-list/vessel-redundancy-group-list.component";
import { VesselRedundancyWcfdiListComponent } from "../vessel-redundancy-wcfdi-list/vessel-redundancy-wcfdi-list.component";
import { VesselRedundancyDiagramListComponent } from "../vessel-redundancy-diagram-list/vessel-redundancy-diagram-list.component";


@Component({
  selector: 'dpi-vessel-hub',
  imports: [MatTabsModule, MatTooltipModule, MatBadgeModule, TrailListComponent, VesselDetailsComponent, VesselPhotosComponent, 
    VesselMachineryListComponent, VesselDpControlListComponent, VesselRedundancyGroupListComponent, VesselRedundancyWcfdiListComponent, 
    VesselRedundancyDiagramListComponent],
  templateUrl: './vessel-hub.component.html',
  styleUrl: './vessel-hub.component.scss'
})
export class VesselHubComponent {
  trailsNum: number;
  photosNum: number;
  machineriesNum: number;
  dpControlNum: number;
  redundancyGroupNum: number;
  redundancyDiagramNum: number;
  wcfdiNum: number;

  constructor() {
    this.trailsNum = 0;
    this.photosNum = 0;
    this.machineriesNum = 0;
    this.dpControlNum = 0;
    this.redundancyGroupNum = 0;
    this.redundancyDiagramNum = 0;
    this.wcfdiNum = 0;
  }

  setTrailsNum(count: number) {
    this.trailsNum = count;
  }

  setPhotosNum(count: number) {
    this.photosNum = count;
  }

  setDpControlNum(count: number) {
    this.dpControlNum = count;
  }

  setMachineriesNum(count: number) {
    this.machineriesNum = count;
  }

  setRedundancyGroupNum(count: number) {
    this.redundancyGroupNum = count;
  }

  setRedundancyDiagramNum(count: number) {
    this.redundancyDiagramNum = count;
  }

  setWcfdiNumNum(count: number) {
    this.wcfdiNum = count;
  }
}
